import React from "react";

import DOMPurify from 'dompurify';
import marked from 'marked';
import {GlobalInfo} from "./context";
import {database} from "./config";
import {toast} from "react-toastify";
import {numberWithCommas, parseNumber} from "./util";
import * as firebase from "firebase/app";
import {postToDiscord} from "./discord";
import {withTranslation} from "react-i18next";

class MyBalancePanel extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      withdrawAmt: "",
      depositAmt: "",
    }
  }


  requestWithdraw() {
    const { t } = this.props;
    let maxAmount = this.context.userData.balanceIsk - (this.context.userData.pendingWithdrawals || 0);
    let amount = parseNumber(this.state.withdrawAmt);
    if (isNaN(amount)) {
      toast.error(t('common:errors.parseError'));
      return;
    }
    // if(amount > 200000000) {
    //   toast.error('Maximum single withdraw amount is 200 million. Please submit multiple requests and contracts. Set a longer expiration as it may take longer due to in-game audits.')
    //   return;
    // }
    if (!this.context.roles.engineer && amount > maxAmount) {
      toast.error(t('pages:frontPage.withdraw.errors.exceedsBalance', { amount: numberWithCommas(amount), maxAmount: numberWithCommas(maxAmount) }));
      return;
    }
    this.setState({
      withdrawAmt: ''
    });
    database.runTransaction((transaction) => {
      let p = [];
      p.push(transaction.update(database.collection("users").doc(this.context.userInfo.id), {
        pendingWithdrawals: firebase.firestore.FieldValue.increment(amount)
      }));
      p.push(transaction.set(database.collection("requests").doc(), {
        timestamp: Date.now(),
        actorUserInfo: this.context.userInfo,
        type: "withdraw",
        amount: amount,
      }));
      return Promise.all(p)
    }).then(() => {
      toast.success(t('common:messages.withdrawalRequested', { amount: numberWithCommas(amount) }));
      postToDiscord({
        channel: "PAYOUT",
        username: "Pandemic Industry",
        content: `${this.context.userInfo.name} requested a payout of ${numberWithCommas(amount)} ISK.`
      });
    })
  }

  render() {
    const { t } = this.props;

    let balanceIsk = this.context.userData.balanceIsk;
    let balancePanda = this.context.userData.balancePanda;
    let pendingOrders = this.context.userData.pendingOrders || 0;
    let pendingDeposits = this.context.userData.pendingDeposits || 0;
    let pendingWithdrawals = this.context.userData.pendingWithdrawals || 0;
    let total = balanceIsk + balancePanda + pendingOrders + pendingDeposits - pendingWithdrawals;

    return <div>
      <div className="card mb-4">
        <h5 className="card-header">
          {t('pages:frontPage.balance.title')}
        </h5>
        <div className={"card-body"}>
          <ul className="list-group mb-3">
            <li className="list-group-item d-flex justify-content-between lh-condensed">
              <div>
                <h6 className="my-0">ISK</h6>
                {/*<small className="text-muted">Brief description</small>*/}
              </div>
              <span>{numberWithCommas(balanceIsk)} ISK</span>
            </li>
            <li className="list-group-item d-flex justify-content-between lh-condensed">
              <div>
                <h6 className="my-0">{t('common:currency.pandacoin')}</h6>
              </div>
              <span>{numberWithCommas(balancePanda)} Panda</span>
            </li>
            {pendingOrders ? <li className="list-group-item d-flex justify-content-between bg-light">
              <div className="text-success">
                <h6 className="my-0">{t('pages:frontPage.balance.pendingOrders')}</h6>
              </div>
              <span className="text-success">{numberWithCommas(pendingOrders)} ISK</span>
            </li> : null}
            {pendingDeposits ? <li className="list-group-item d-flex justify-content-between lh-condensed">
              <div>
                <h6 className="my-0">{t('pages:frontPage.balance.pendingDeposits')}</h6>
              </div>
              <span className="text-muted">{numberWithCommas(pendingDeposits)} ISK</span>
            </li> : null}
            {pendingWithdrawals ? <li className="list-group-item d-flex justify-content-between lh-condensed">
              <div>
                <h6 className="my-0">{t('pages:frontPage.balance.pendingWithdrawals')}</h6>
              </div>
              <span className="text-muted">{numberWithCommas(pendingWithdrawals)} ISK</span>
            </li> : null}
            <li className="list-group-item d-flex justify-content-between">
              <span>{t('pages:frontPage.balance.totalBalance')}</span>
              <span><strong>{numberWithCommas(total)} ISK</strong></span>
            </li>
          </ul>

        </div>
      </div>
      {/* TODO: Withdrawal request form removed from frontend — withdrawals now handled via in-game mission requests to avoid contract taxes. Backend endpoints and Firestore request handling still exist and can be re-enabled if needed. */}
      <div className="card mb-4">
        <h5 className="card-header">
          {t('pages:frontPage.withdraw.title')}
        </h5>
        <div className={"card-body"}>
          <div className={"alert alert-info"}>
            <strong>Withdrawals have moved to in-game missions.</strong> To withdraw ISK, create a mission request in-game. This avoids the 8% contract tax.
          </div>
          <p>A finance officer will fulfill your mission request directly.</p>
        </div>
      </div>
        <div className="card mb-4">
        <h5 className="card-header">
         {t('pages:frontPage.deposit.title')}
        </h5>
        <div className={"card-body"}>
          <ol>
            <li>{t('pages:frontPage.deposit.step1')}</li>
            <li>{t('pages:frontPage.deposit.step2')}</li>
            <li>{t('pages:frontPage.deposit.step3')}</li>
            <li>{t('pages:frontPage.deposit.step4')}</li>
          </ol>
        </div>
      </div>
      {/*<div className="card mb-4">*/}
      {/*  <h5 className="card-header">*/}
      {/*    Log deposit*/}
      {/*  </h5>*/}
      {/*  <div className={"card-body"}>*/}
      {/*    <div className={"input-group"}>*/}
      {/*      <div className="input-group-prepend">*/}
      {/*        <span className="input-group-text">Amount</span>*/}
      {/*      </div>*/}
      {/*      <input className={"form-control"} type={"text"} placeholder="accepts suffixes like 1.5M" value={this.state.depositAmt} onChange={(e) => this.setState({depositAmt: e.target.value})}/>*/}
      {/*      <div className="input-group-append">*/}
      {/*        <button className={"btn btn-primary"} onClick={e => this.requestWithdraw()}>Log</button>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}
    </div>
  }
}

MyBalancePanel.contextType = GlobalInfo;

const TranslatedMyBalancePanel = withTranslation(['pages', 'common'])(MyBalancePanel);


class FrontPage extends React.Component {
  render() {
    const { t } = this.props;
    const infoMarkdown = t('pages:frontPage.infoMarkdown');
    let html = {__html: DOMPurify.sanitize(marked(infoMarkdown))};

    return <div className={"container"}>
      <h1>{t('pages:frontPage.welcome')}</h1>
      <div className="row">
        <div className="col-sm-6">
          <TranslatedMyBalancePanel/>
        </div>
        <div className="col-sm-6">
          <div className="card">
            <h5 className="card-header">
              {t('pages:frontPage.basicInfo')}
            </h5>
            {/*onClick={evt => evt.preventDefault()}*/}
            <div className={"card-body"} dangerouslySetInnerHTML={html}/>
          </div>
        </div>
      </div>
    </div>
  }
}

const TranslatedFrontPage = withTranslation(['pages', 'common'])(FrontPage);
export { TranslatedFrontPage as FrontPage };